<template>
  <component :is="Impl" :colors="colors" :background-variant="backgroundVariant" :title="title">
    <slot></slot>
  </component>
</template>

<script setup>
import { useThemedComponent } from "@/composables/useThemedComponent.js";

defineProps({
  colors: {type: Object, required: true},
  backgroundVariant: {type: Number, default: 1},
  title: { type: String, required: false, default: null}
});

const Impl = useThemedComponent("sectionContainer");
</script>
